import * as React from "react";
import { SVGProps } from "react";

const FlagGhana = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1493_10338)">
      <path d="M3 5H21V18.5H3V5Z" fill="#006B3F" />
      <path d="M3 5H21V14H3V5Z" fill="#FCD116" />
      <path d="M3 5H21V10H3V5Z" fill="#CE1126" />
      <path
        d="M12.0012 10L13.2385 14L10 11.5275H14L10.7638 14L12.0012 10Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1493_10338">
        <rect width="16" height="12" fill="white" transform="translate(4 6)" />
      </clipPath>
    </defs>
  </svg>
);
export default FlagGhana;
